import { render, staticRenderFns } from "./addAuthorization.vue?vue&type=template&id=62856391&scoped=true"
import script from "./addAuthorization.vue?vue&type=script&lang=js"
export * from "./addAuthorization.vue?vue&type=script&lang=js"
import style0 from "./addAuthorization.vue?vue&type=style&index=0&id=62856391&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62856391",
  null
  
)

export default component.exports